__turbopack_context__.v({
  "name": "index-module-scss-module__29ZPDq__name",
});
